module.exports = __webpack_public_path__ + "img/mx.b370c423.svg";